<!--
/**
* @name: platformDetail.vue
* @description: 平台销售价格详情
* @author: 于海威
* @create: 2020/08/24 10:13:01
* @update: 2020/08/24 10:13:01
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-form titleWidth="90px" contentWidth="100%" gutter="20px" titleAlign="left">
      <y-form-item title="任务编号：">{{ price.recordCode }}</y-form-item>
      <y-form-item title="适用销售渠道：">{{ price.saleChannelName }}</y-form-item>
      <y-form-item title="记录状态：">
        <span v-if="price.status">{{ price.status == "WAIT" ? "待审批" : price.status == "SUCCESS" ? "已审批" : "已作废" }}</span>
      </y-form-item>
      <y-form-item title="记录数量：">{{ price.recordNum }}</y-form-item>
      <y-form-item title="有效数量：">{{ price.validNum }}</y-form-item>
      <y-form-item title="执行数量：">{{ price.executeNum }}</y-form-item>
      <y-form-item title="创建时间：">{{ price.createTime }}</y-form-item>
      <y-form-item title="价格信息：" align="top">
        <k-table :data="dataList" :columns="initColumns()"></k-table>
      </y-form-item>
    </y-form>
  </y-view>
</template>

<script>
import { NESTLE_GOODS_BACK_SERVER_GOODS_PRICE_RECORD_DETAIL, NESTLE_GOODS_BACK_SERVER_GOODS_PRICE_RECORD_AUDIT_DETAIL } from "@/assets/modules/apiList";
export default {
  data() {
    return {
      isLoading: false,
      price: {},
      dataList: [],
      recordId: "",
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "商品货号",
          field: "goodsCodeSale",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "商品名称",
          field: "goodsNameSale",
          style: {
            width: 120,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "仓库",
          field: "warehouseName",
          style: {
            width: 100,
            textAlign: "center",
          },
        },
        {
          name: "批次号",
          field: "batchNo",
          style: {
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "三方批次号",
          field: "thirdBatchNo",
          style: {
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "规格",
          field: "spec",
          style: {
            width: 100,
            textAlign: "center",
          },
        },
        {
          name: () => {
            return (
              <div>
                <p>平台价</p>
                <p>(单价/总价)</p>
              </div>
            );
          },
          field: "",
          style: {
            width: 100,
            textAlign: "center",
          },
          customRender: (row) => {
            const statusStr = (
              <span>
                {row.price}/{row.allPrice}
              </span>
            );
            return <div>{statusStr}</div>;
          },
        },
        {
          name: () => {
            return (
              <div>
                <p>店铺销售价</p>
                <p>(单价/总价)</p>
              </div>
            );
          },
          field: "",
          style: {
            width: 100,
            textAlign: "center",
          },
          customRender: (row) => {
            const statusStr = (
              <span>
                {row.storeSpecPrice || "--"}/{row.storePrice || "--"}
              </span>
            );
            return <div>{statusStr}</div>;
          },
        },
        {
          name: "记录状态",
          field: "recordStatus",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => {
            const statusStr = row.recordStatus == "SUCCESS" ? <span>导入成功</span> : <span>导入失败</span>;
            return <div>{statusStr}</div>;
          },
        },
        {
          name: "错误原因",
          field: "failedCause",
          style: {
            width: 100,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "执行时间",
          field: "executeTime",
          style: {
            width: 100,
            textAlign: "center",
          },
        },
        {
          name: "操作",
          field: "",
          style: {
            width: 60,
            textAlign: "center",
          },
          customRender: (row) => {
            const auditButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onAudit(row);
                }}
              >
                审核
              </a>
            );
            if (row.recordStatus == "SUCCESS" && row.status == "WAIT") {
              return <div>{auditButton}</div>;
            }
          },
        },
      ];
    },
    onAudit(row) {
      this.$dialog({
        title: "提示",
        content: "是否确认审核此价格？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_GOODS_BACK_SERVER_GOODS_PRICE_RECORD_AUDIT_DETAIL,
            para: { id: row.id },
          })
            .then((res) => {
              this.getPriceDetail(this.recordId);
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    getPriceDetail(id) {
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_PRICE_RECORD_DETAIL,
        para: { id },
      }).then((res) => {
        this.price = res;
        this.dataList = res.goodsPriceDetailVOList || [];
      });
    },
  },
  created() {
    const { id } = this.$route.query;
    this.recordId = id;
    if (id) {
      this.getPriceDetail(id);
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id } = to.query;
    this.price = {};
    this.dataList = [];
    this.recordId = id;
    if (id) {
      this.getPriceDetail(id);
    }
    next();
  },
};
</script>

<style lang="postcss" module="css"></style>
